import {createContentfulClient} from '../../libs/contentful';
import {getServiceSiteFooterBanner} from '../index';
import {getAllStories} from './index';
import Layout from '../../components/common/Layout';
import Meta from '../../components/common/Meta';
import Breadcrumb from '../../components/common/Breadcrumb';
import Main from '../../components/section/stories/post/Main';
import Careers from '../../components/section/common/Careers';

export default function StoriesPost({story, serviceSiteFooterBanner}) {
    let breadcrumbItems = [
        {
            key: 1,
            text: 'CRISP TOP',
            href: '/',
        },
        {
            key: 2,
            text: 'STORIES',
            href: '/stories',
        },
        {
            key: 3,
            text: `${story.fields.title}`,
            href: `/stories/${story.fields.slug}`,
        },
    ];

    const contentArray = story.fields.body.content;
    const contentNodeTypeArray = contentArray.find(
        (item) => item.content[0]?.value.length > 1
    );
    let image = "https://www.crisp.co.jp/image/ogp/ogp.jpg"
    if (story.fields.image) {
        image = `https:` + story.fields.image.fields.file.url + `?fm=webp&q=50`
    }

    return (
        <Layout>
            <Meta
                title={story.fields.title}
                description={
                    contentNodeTypeArray.content[0].value.substr(0, 120) + '...'
                }
                ogImage={image}
                twitterImage={image}
            />
            <Breadcrumb items={breadcrumbItems}/>
            <Main story={story}/>
            <Careers serviceSiteFooterBanner={serviceSiteFooterBanner}/>
        </Layout>
    );
}

export async function getStaticPaths() {
    const client = createContentfulClient();
    const stories = await getAllStories(client);
    const paths = stories.items.map((story) => ({
        params: {slug: story.fields.slug},
    }));
    return {paths: paths, fallback: false};
}

export const getStaticProps = async (params) => {
    const {slug} = params.params;
    const client = createContentfulClient();
    const story = await getStoryBySlug(client, slug);
    const serviceSiteFooterBanner = await getServiceSiteFooterBanner(client);

    return {
        props: {
            story: story.items[0],
            serviceSiteFooterBanner,
        },
    };
};

export async function getStoryBySlug(client, slug) {
    return await client
        .getEntries({
            content_type: 'serviceSiteStories',
            limit: 1,
            'fields.slug': slug,
        })
        .catch((error) => {
            return error;
        });
}
